import React, { useCallback } from 'react'
import { InfiniteLoader } from 'react-virtualized/dist/commonjs/InfiniteLoader'

export const SimpleInfiniteLoader = ({ rows, onRenderLastItem, loading, children, ...rest }) => {
  const loadMoreRows = useCallback(() => {
    if (onRenderLastItem) {
      onRenderLastItem()
    }
  }, [onRenderLastItem])

  const isRowLoaded = useCallback(
    ({ index }) => {
      if (loading) {
        return true
      }
      return !!rows[index]
    },
    [rows, loading]
  )

  const rowsCount = loading ? rows.length : rows.length + 1

  return (
    <InfiniteLoader isRowLoaded={isRowLoaded} loadMoreRows={loadMoreRows} rowCount={rowsCount} {...rest}>
      {children}
    </InfiniteLoader>
  )
}
